import { render } from "./BlogPrpFacelifting.vue?vue&type=template&id=d67470ac"
import script from "./BlogPrpFacelifting.vue?vue&type=script&lang=js"
export * from "./BlogPrpFacelifting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__